import { render } from "./Merchants.vue?vue&type=template&id=5cfc53e2&scoped=true"
import script from "./Merchants.vue?vue&type=script&lang=js"
export * from "./Merchants.vue?vue&type=script&lang=js"

import "./Merchants.vue?vue&type=style&index=0&id=5cfc53e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfc53e2"]])

export default __exports__